mutation UpdatePlatformBunnySettings(
  $platformId: ID!
  $input: UpdateBunnySettingsInput!
) {
  updatePlatformBunnySettings(platformId: $platformId, input: $input) {
    id
    bunnySettings {
      libraryId
      cdnHostname
      apiKeyMask
      connectedAt
    }
  }
}
